<template>
    <div>
        <messageTitle :avatar="message.avatar"
                :nick="nick"
              :isMine="isMine"
              :avatarType="avatar"
              :circular="isCustom"
              :showNick="!(isCustom && isMine)"
              :showAvatar="!(!isCustom && isMine)"
              :size="isCustom ? 'middle' : 'small'">
            <img class="image-element" :src="imageUrl">
            <div class="image-overlay" v-if="showProgress">
                <van-loading vertical>{{percentage}}%</van-loading>
            </div>
        </messageTitle>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { messageSenderRole, messageIsCustom } from '../../utils';
import messageTitle from '../messageTitle';
export default {
    name: "imageElement",
    components: {
	    messageTitle
    },
    props: {
        payload: {
            type: Object,
            required: true
        },
        message: {
            type: Object,
            required: true
        }
    },
	data() {
		return {}
	},
	computed: {
		...mapGetters('instantMessaging', ['isCustom', 'isC2C']),
		...mapState('instantMessaging', ['currentMemberList']),
		isMine() {
			return this.message.flow === 'out'
		},
		imageUrl() {
			const url = this.payload.imageInfoArray[0].url;
			if (typeof url !== 'string') {
				return ''
			}
			return url.slice(0, 2) === '//' ? `https:${url}` : url
		},
		showProgress() {
			return this.$parent.message.status === 'unSend'
		},
		percentage() {
			return Math.floor((this.$parent.message.progress || 0) * 100)
		},
		nick() {
			if (this.isC2C) {
				return `${this.message.nick || `暂无昵称（${this.message.from}）`}`;
			} else {
				return `${this.message.nick}(${messageSenderRole(this.message, this.currentMemberList)})`
			}
		},
		avatar() {
			if (messageIsCustom(this.message, this.currentMemberList)) {
				return 'custom';
			} else {
				return 'staff';
			}
		}
	},
	watch: {},
	mounted() {
	},
	methods: {}
}
</script>

<style scoped lang="less">
.image-element {
    max-width: 200px;
    border-radius: 10px;
}

.image-overlay {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: #000;
    opacity: .7;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
}
</style>
